import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/zmiany-w-prawie/components/ZmianyMonthClient.tsx");
